import { useParams, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import GUIDE_TEMPLATE_RAW from './message-box-guide.md?raw';

export default function GroupJoinDoc() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [content, setContent] = useState('');

  useEffect(() => {
    if (id && token) {
      const rendered = GUIDE_TEMPLATE_RAW
        .replace(/<TOKEN>/g, token!)
        .replace(/<GROUP_ID>/g, id!);
      setContent(rendered);
    }
  }, [id, token]);

  if (!id || !token) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen px-4">
        <div className="text-6xl mb-4">🔗</div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          链接不完整
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          加群链接缺少必要参数，请获取完整的邀请链接
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <pre className="text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap word-break break-all font-mono leading-relaxed">
        {content}
      </pre>
    </div>
  );
}
